import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hello, My name is <span className="purple">Barbora Mitzova </span>
            from <span className="purple"> Kosice, Slovakia.</span>
            <br />
            I am a recent graduate of the Faculty of Arts.
            <br />
            I am actively seeking a role in UX/UI or graphic design where I can turn ideas into meaningful visual experiences.
            <br />
            <br />
            Outside of design work, things that keep me inspired:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Gaming — a constant source of UI and visual inspiration
            </li>
            <li className="about-activity">
              <ImPointRight /> Game Development — where design and interaction meet
            </li>
            <li className="about-activity">
              <ImPointRight /> Illustration & Digital Painting
            </li>
            <li className="about-activity">
              <ImPointRight /> Reading
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Whatever it is you're seeking won't come in the form you're expecting."{" "}
          </p>
          <footer className="blockquote-footer">Haruki Murakami</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
